(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trobart-journey-teaser"] && !Shopify.designMode) return;
  try {
    
(function(){
  function mount(root){
    if(root.dataset.mounted)return;root.dataset.mounted='1';
    var query=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)'),frame=0;
    function draw(){frame=0;if(query&&query.matches)return;var rect=root.getBoundingClientRect();if(rect.bottom<0||rect.top>window.innerHeight)return;root.style.setProperty('--tj-drift',Math.max(-1,Math.min(1,(window.innerHeight*.5-rect.top-rect.height*.5)/(window.innerHeight*.65))).toFixed(4));}
    function schedule(){if(!frame)frame=requestAnimationFrame(draw);}
    function unload(event){if(!event.target.contains(root))return;window.removeEventListener('scroll',schedule);window.removeEventListener('resize',schedule);document.removeEventListener('shopify:section:unload',unload);if(frame)cancelAnimationFrame(frame);}
    window.addEventListener('scroll',schedule,{passive:true});window.addEventListener('resize',schedule,{passive:true});document.addEventListener('shopify:section:unload',unload);schedule();
  }
  function init(){document.querySelectorAll('[data-journey-teaser]').forEach(mount);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();document.addEventListener('shopify:section:load',init);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trobart-journey"] && !Shopify.designMode) return;
  try {
    
/* Actual Trobart editions. Preview theme only; no cart, account or tracking writes. */
(function(){
  'use strict';
  /* No wheel interception. Only the camera interpolates; the page scrolls normally. */
  function mountCinema(root,media,controllers){
    var chapters=root.querySelector('.tbj__chapters'),screen=root.querySelector('[data-j-cinema]');
    var panels=Array.from(root.querySelectorAll('[data-stop]')),rail=root.querySelector('.tbj__rail'),hero=root.querySelector('.tbj__hero');
    var colors=[[237,240,230],[223,232,222],[237,226,213],[226,231,226],[217,231,232],[229,223,235]];
    var markers=[],enabled=false,frame=0,position=0,step=800,height=760,top=0,active=-1,pendingFocus=null;
    var styleStep=.68,zoomSpan=1.4,ranges=[],beats=[],cursor=0,lastDraw=0,continueButton=root.querySelector('[data-j-continue]');
    controllers.forEach(function(c){
      var styles=(c.editions.length-1)*styleStep,extra=styles+zoomSpan;
      ranges.push({start:cursor,styles:styles,extra:extra});
      c.editions.forEach(function(_,i){beats.push({index:ranges.length-1,point:cursor+i*styleStep});});
      beats.push({index:ranges.length-1,point:cursor+styles+zoomSpan*.56});cursor+=extra+1;
    });
    var last=ranges[ranges.length-1],duration=last.start+last.extra;
    var pointer={x:0,y:0,tx:0,ty:0},disposed=false;
    function clamp(n,a,b){return Math.max(a,Math.min(b,n));}
    function smooth(a,b,n){var t=clamp((n-a)/(b-a),0,1);return t*t*(3-2*t);}
    function softer(a,b,n){var t=clamp((n-a)/(b-a),0,1);return t*t*t*(t*(t*6-15)+10);}
    function cameraAt(time){
      var i=ranges.length-1;while(i>0&&time<ranges[i].start)i--;
      var range=ranges[i],local=time-range.start,drift=range.extra ? .12 : 0;
      if(range.extra&&local<=range.extra)return i+drift*clamp(local/range.extra,0,1);
      if(i===ranges.length-1)return i+drift;
      return i+drift+(1-drift)*clamp(local-range.extra,0,1);
    }
    function current(index){
      if(index===active)return;active=index;
      panels.forEach(function(el,i){el.classList.toggle('is-current',i===index);el.inert=i!==index;el.setAttribute('aria-hidden',String(i!==index));});
      root.querySelectorAll('[data-j-stop-link]').forEach(function(a){if(a.dataset.jStopLink===panels[index].dataset.stop)a.setAttribute('aria-current','step');else a.removeAttribute('aria-current');});
    }
    function header(){
      var el=document.querySelector('sticky-header');var offset=clamp(el?el.getBoundingClientRect().bottom:0,0,220);
      var bar=document.querySelector('#PBarNextFrame');var inset=bar?clamp(bar.getBoundingClientRect().height,0,80):0;
      var railHeight=rail.getBoundingClientRect().height||66;top=offset+railHeight;
      height=Math.max(360,window.innerHeight-top-inset);
      root.style.setProperty('--tbj-header-offset',offset+'px');root.style.setProperty('--j-rail',railHeight+'px');root.style.setProperty('--j-height',height+'px');
    }
    function measure(){
      header();step=height*(window.innerWidth<750?1.08:1.12);
      root.style.setProperty('--j-style-distance',(styleStep*step)+'px');
      root.style.setProperty('--j-zoom-distance',(zoomSpan*step)+'px');
      if(enabled){chapters.style.height=((duration+.7)*step+height)+'px';markers.forEach(function(m,i){m.style.top=(ranges[i].start*step)+'px';});}
    }
    function draw(){
      frame=0;if(disposed||document.hidden){lastDraw=0;return;}
      header();
      if(!enabled)return;
      var rect=chapters.getBoundingClientRect();var target=clamp((top-rect.top)/step,0,duration);
      var tick=performance.now(),elapsed=lastDraw?Math.min(34,tick-lastDraw):16;lastDraw=tick;
      position+=(target-position)*(1-Math.exp(-elapsed/125));if(Math.abs(target-position)<.001)position=target;
      pointer.x+=(pointer.tx-pointer.x)*.12;pointer.y+=(pointer.ty-pointer.y)*.12;
      var camera=cameraAt(position),index=Math.min(panels.length-1,Math.round(camera));current(index);
      root.style.setProperty('--j-progress',((position+.2)/(duration+.4)).toFixed(4));
      root.style.setProperty('--j-pointer-x',pointer.x.toFixed(3)+'deg');root.style.setProperty('--j-pointer-y',pointer.y.toFixed(3)+'deg');
      var from=Math.min(panels.length-1,Math.floor(camera)),to=Math.min(from+1,panels.length-1),blend=smooth(.30,.78,camera-from);
      screen.style.backgroundColor='rgb('+colors[from].map(function(c,i){return Math.round(c+(colors[to][i]-c)*blend);}).join(',')+')';
      panels.forEach(function(el,i){
        var d=camera-i,opacity=d<0?smooth(-.70,-.22,d):1-smooth(.30,.78,d);
        el.style.visibility=opacity>.002?'visible':'hidden';el.style.setProperty('--j-opacity',opacity.toFixed(4));
        if(opacity<=.002){controllers[i].release();return;}
        var local=position-ranges[i].start,close=clamp((local-ranges[i].styles)/zoomSpan,0,1);
        var zoom=softer(.04,.34,close)*(1-softer(.78,.99,close));
        controllers[i].scroll(clamp(local/styleStep,0,controllers[i].editions.length-1),zoom,close);
        var travel=clamp(d,-1,1),direction=i%2===0?1:-1;
        /* Hold the outer camera steady during the straight close-up pan. */
        if(zoom){var steady=cameraAt(ranges[i].start+ranges[i].styles+zoomSpan*.56)-i;travel=travel*(1-zoom)+steady*zoom;}
        el.style.setProperty('--j-x',(-travel*window.innerWidth*.27)+'px');
        el.style.setProperty('--j-y',(Math.sin(travel*Math.PI)*height*.07*direction)+'px');
        el.style.setProperty('--j-z',(travel*(travel>0?160:220))+'px');
        el.style.setProperty('--j-rx',(travel*9*direction)+'deg');
        el.style.setProperty('--j-ry',(-5-travel*32)+'deg');
        el.style.setProperty('--j-rz',((i%2===0?-2:2)-travel*14*direction)+'deg');
        el.style.setProperty('--j-scale',(1+travel*(travel>0?.18:.12)).toFixed(4));
        el.style.setProperty('--j-blur',(smooth(.26,.88,Math.abs(d))*6).toFixed(3)+'px');
        el.style.setProperty('--j-drift',(travel*500)+'px');el.style.setProperty('--j-copy-y',(-travel*42)+'px');
      });
      var heroRect=hero.getBoundingClientRect();hero.style.setProperty('--j-hero',clamp(-heroRect.top/(heroRect.height||1),0,1).toFixed(4));
      if(pendingFocus){
        var now=performance.now(),scroll=window.scrollY;
        if(Math.abs(scroll-pendingFocus.scroll)>.5||Math.abs(top-pendingFocus.top)>.5){pendingFocus.quiet=now;pendingFocus.scroll=scroll;pendingFocus.top=top;}
        /* Dawn's collapsing header changes the anchor offset during a jump.
           Once native scrolling rests, align with its actual final height. */
        if(now-pendingFocus.quiet>120){
          if(Math.abs(target-pendingFocus.point)>.012){window.scrollTo({top:scroll+rect.top+pendingFocus.point*step-top,behavior:'instant'});pendingFocus.quiet=now;}
          else if(Math.abs(target-position)<.01){pendingFocus.el.focus({preventScroll:true});pendingFocus=null;}
        }
        if(pendingFocus&&now-pendingFocus.started>2400)pendingFocus=null;
      }
      if(pendingFocus||Math.abs(target-position)>.001||Math.abs(pointer.tx-pointer.x)>.005||Math.abs(pointer.ty-pointer.y)>.005)schedule();else lastDraw=0;
    }
    function schedule(){if(!frame&&!disposed)frame=requestAnimationFrame(draw);}
    function enable(){
      if(enabled)return;enabled=true;active=-1;root.classList.add('is-cinematic');root.dataset.jMotion='cinematic';controllers.forEach(function(c){c.start();});
      panels.forEach(function(el){var m=document.createElement('div');m.className='tbj__cue';m.id=el.id;m.tabIndex=-1;m.setAttribute('aria-hidden','true');el.removeAttribute('id');chapters.appendChild(m);markers.push(m);});
      measure();position=clamp((top-chapters.getBoundingClientRect().top)/step,0,duration);draw();
    }
    function disable(){
      enabled=false;root.classList.remove('is-cinematic');root.dataset.jMotion='static';chapters.style.removeProperty('height');screen.style.removeProperty('background-color');
      panels.forEach(function(el,i){if(markers[i])el.id=markers[i].id;el.removeAttribute('style');el.removeAttribute('aria-hidden');el.inert=false;el.classList.remove('is-current');});
      markers.forEach(function(m){m.remove();});markers=[];hero.style.removeProperty('--j-hero');root.style.removeProperty('--j-pointer-x');root.style.removeProperty('--j-pointer-y');pendingFocus=null;active=-1;
      controllers.forEach(function(c){c.stop();});
      if(frame)cancelAnimationFrame(frame);frame=0;
    }
    function update(){
      if(disposed)return;
      if(media&&media.matches||window.innerHeight<500){if(enabled)disable();else root.dataset.jMotion='static';header();return;}
      if(!enabled)enable();else{measure();schedule();}
    }
    function move(event){
      if(!enabled||event.pointerType!=='mouse')return;
      var rect=screen.getBoundingClientRect();if(event.clientY<rect.top||event.clientY>rect.bottom)return;
      pointer.tx=clamp((event.clientX/window.innerWidth-.5)*5,-2.5,2.5);pointer.ty=clamp((.5-(event.clientY-rect.top)/height)*4,-2,2);schedule();
    }
    function leave(){pointer.tx=0;pointer.ty=0;schedule();}
    function cancelJump(){pendingFocus=null;}
    function continueJourney(){
      if(!enabled)return;
      var next=beats.find(function(beat){return beat.point>position+.12;});
      if(next)jump(next.index,next.point,continueButton);
      else{pendingFocus=null;var finish=root.querySelector('#j-finish');finish.scrollIntoView({behavior:'smooth',block:'start'});finish.focus({preventScroll:true});}
    }
    function visibility(){if(document.hidden){if(frame)cancelAnimationFrame(frame);frame=0;}else schedule();}
    function resize(){if(document.activeElement&&/INPUT|TEXTAREA/.test(document.activeElement.tagName))return;update();}
    function unload(event){if(!event.target.contains(root))return;disposed=true;disable();window.removeEventListener('scroll',schedule);window.removeEventListener('resize',resize);window.removeEventListener('wheel',cancelJump);window.removeEventListener('touchstart',cancelJump);root.removeEventListener('pointerdown',cancelJump);root.removeEventListener('pointermove',move);root.removeEventListener('pointerleave',leave);continueButton.removeEventListener('click',continueJourney);document.removeEventListener('visibilitychange',visibility);document.removeEventListener('shopify:section:unload',unload);if(media&&media.removeEventListener)media.removeEventListener('change',update);}
    window.addEventListener('scroll',schedule,{passive:true});window.addEventListener('resize',resize,{passive:true});window.addEventListener('wheel',cancelJump,{passive:true});window.addEventListener('touchstart',cancelJump,{passive:true});root.addEventListener('pointerdown',cancelJump,{passive:true});root.addEventListener('pointermove',move,{passive:true});root.addEventListener('pointerleave',leave);document.addEventListener('visibilitychange',visibility);document.addEventListener('shopify:section:unload',unload);
    continueButton.addEventListener('click',continueJourney);
    if(media&&media.addEventListener)media.addEventListener('change',update);update();
    if(enabled&&location.hash){var initial=markers.findIndex(function(m){return '#'+m.id===location.hash;});if(initial>=0)jump(initial,ranges[initial].start,null,'auto');}
    function jump(index,point,focusTarget,behavior){var now=performance.now();pendingFocus={index:index,point:point,el:focusTarget||panels[index],started:now,quiet:now,scroll:window.scrollY,top:top};window.scrollTo({top:window.scrollY+chapters.getBoundingClientRect().top+point*step-top,behavior:behavior||'smooth'});schedule();}
    return {
      refresh:schedule,
      navigate:function(href){pendingFocus=null;if(!enabled)return false;var index=markers.findIndex(function(m){return '#'+m.id===href;});if(index<0)return false;jump(index,ranges[index].start);return true;},
      selectStyle:function(id,style,focusTarget){if(!enabled)return false;var index=panels.findIndex(function(el){return el.dataset.stop===id;}),choice=controllers[index].editions.findIndex(function(e){return e.style===style;});if(choice<0)return false;jump(index,ranges[index].start+choice*styleStep,focusTarget);return true;}
    };
  }
  function mount(root){
    if(root.dataset.jMounted)return;
    root.dataset.jMounted='true';
    var config=JSON.parse(root.querySelector('[data-j-config]').textContent);
    var copy=config.copy, scenes=config.scenes;
    var preview=root.dataset.preview;
    var base=(root.dataset.root||'/').replace(/\/$/,'');
    var storageKey='trobart-journey-v1-'+(preview||'main');
    var saved={};
    try{var stored=JSON.parse(sessionStorage.getItem(storageKey)||'{}');if(stored&&typeof stored==='object')saved=stored;}catch(_){}
    var known=new Set(scenes.map(function(s){return s.id;}));
    Object.keys(saved).forEach(function(id){var s=scenes.find(function(s){return s.id===id;});if(!known.has(id)||!s.editions.some(function(e){return e.style===saved[id];}))delete saved[id];});
    var motionQuery=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)');
    var reduced=motionQuery&&motionQuery.matches;
    function motionChanged(){reduced=motionQuery.matches;}
    if(motionQuery&&motionQuery.addEventListener)motionQuery.addEventListener('change',motionChanged);
    function localUrl(path){
      var u=new URL(path,location.origin);
      if(u.origin!==location.origin)return u.href;
      if(base&&u.pathname.indexOf(base+'/')!==0&&u.pathname!==base)u.pathname=base+u.pathname;
      if(preview&&/^\d+$/.test(preview))u.searchParams.set('preview_theme_id',preview);
      return u.pathname+u.search+u.hash;
    }
    function persist(){try{sessionStorage.setItem(storageKey,JSON.stringify(saved));}catch(_){} }
    function announce(text){root.querySelector('[data-j-announcement]').textContent=text;}
    function selected(scene,element){return scene.editions.find(function(e){return e.style===element.dataset.style;})||scene.editions[0];}
    function makeLinkCard(edition,scene){
      var a=document.createElement('a');a.className='tbj__saved-card';a.href=localUrl(edition.url);
      var img=document.createElement('img');img.src=edition.thumb;img.alt=scene.place+' · '+edition.label;img.loading='lazy';img.width=84;img.height=95;
      var box=document.createElement('div'),title=document.createElement('strong'),small=document.createElement('small'),cta=document.createElement('span');
      title.textContent=scene.place;small.textContent=scene.type+' · '+edition.label;cta.textContent=copy.viewMap+' ↗';box.append(title,small,cta);a.append(img,box);return a;
    }
    function paintSave(scene,el){var button=el.querySelector('[data-j-save]'),active=saved[scene.id]===el.dataset.style;button.setAttribute('aria-pressed',String(active));button.querySelector('span').textContent=active?copy.saved:copy.save;}
    function updateSaved(){
      var list=root.querySelector('[data-j-saved]');list.replaceChildren();
      var count=Object.keys(saved).length;root.querySelectorAll('[data-j-count]').forEach(function(n){n.textContent=String(count);});
      root.querySelector('[data-j-saved-heading]').textContent=count?copy.savedTitle:copy.finishTitle;
      root.querySelector('[data-j-finish-intro]').textContent=count?copy.savedIntro:copy.finishIntro;
      scenes.forEach(function(scene){
        var el=root.querySelector('[data-stop="'+scene.id+'"]');paintSave(scene,el);
        var active=!!saved[scene.id];
        if(active){var edition=scene.editions.find(function(e){return e.style===saved[scene.id];});list.appendChild(makeLinkCard(edition,scene));}
      });
      list.hidden=!count;
    }
    var cinema=null,controllers=[],assets=new Map();
    function ready(src){
      var asset=assets.get(src);if(asset)return asset.state==='ready';
      asset={state:'loading'};assets.set(src,asset);var preload=new Image();
      preload.onload=function(){
        function decoded(){asset.state='ready';if(cinema)cinema.refresh();}
        if(preload.decode)preload.decode().then(decoded,decoded);else decoded();
      };
      preload.onerror=function(){asset.state='error';announce(copy.imageError);if(cinema)cinema.refresh();};
      preload.src=src;return asset.state==='ready';
    }
    scenes.forEach(function(scene){
      var el=root.querySelector('[data-stop="'+scene.id+'"]');
      var teaserStyle=scene.id==='territory'?new URL(location.href).searchParams.get('trobart_style'):null;
      var initial=scene.editions.find(function(e){return e.style===saved[scene.id];})||scene.editions.find(function(e){return e.style===teaserStyle;})||scene.editions[0];
      el.dataset.style=initial.style;el.dataset.view='full';
      var img=el.querySelector('[data-j-image]'),stage=el.querySelector('[data-j-stage]');
      var requestId=0,scrolling=false,lastPhase=0,lastZoom=0,lastFlight=0,blendImage=null,ambientBlend=null,orbitBlend=null;
      var print=el.querySelector('[data-j-print]'),focus=scene.zoom||{x:.5,y:.5,scale:2.3};
      var atlas=null,atlasStyle='',atlasNodes=[];
      el.dataset.jDetailTilesLoaded='0';
      var ambient=el.querySelector('[data-j-ambient]'),orbit=el.querySelector('[data-j-orbit]');
      var order=scene.editions.slice();
      if(teaserStyle&&order.some(function(e){return e.style===teaserStyle;}))order.sort(function(a,b){return (a.style===teaserStyle?-1:0)-(b.style===teaserStyle?-1:0);});
      function source(node,src){if(node.getAttribute('src')!==src)node.src=src;}
      function syncSelection(edition){
        el.dataset.style=edition.style;
        el.querySelector('[data-j-edition]').textContent=edition.label;
        el.querySelector('[data-j-product]').href=localUrl(edition.url);
        el.querySelectorAll('[data-j-style]').forEach(function(b){b.setAttribute('aria-pressed',String(b.dataset.style===edition.style));});
        syncView();
        paintSave(scene,el);
      }
      function syncView(){
        var detail=el.dataset.view==='detail'||scrolling&&lastZoom>.3;
        el.querySelectorAll('[data-j-view]').forEach(function(b){b.setAttribute('aria-pressed',String((b.dataset.jView==='detail')===detail));});
      }
      function applyZoom(amount,edition){
        var w=stage.clientWidth,h=stage.clientHeight,fit=Math.min(w/edition.width,h/edition.height);
        /* Ease along one straight line only after the approach has settled. */
        var t=Math.max(0,Math.min(1,(lastFlight-.34)/.44));t=t*t*t*(t*(t*6-15)+10);
        var path=focus.path||[[focus.x,focus.y],[focus.x,focus.y]],start=path[0],end=path[path.length-1];
        var fx=start[0]+(end[0]-start[0])*t;
        var fy=start[1]+(end[1]-start[1])*t;
        var iw=edition.width*fit,ih=edition.height*fit,x=w?(w-iw)/2+iw*fx:0,y=h?(h-ih)/2+ih*fy:0;
        var scale=1+(focus.scale-1)*amount;
        /* Size the image plane at its final painted resolution. A transformed
           low-resolution compositing surface would soften even native crops. */
        if(amount&&w&&h){print.style.width=(w*scale)+'px';print.style.height=(h*scale)+'px';}
        else{print.style.removeProperty('width');print.style.removeProperty('height');}
        print.style.setProperty('--j-map-scale',scale.toFixed(4));
        print.style.setProperty('--j-print-x',((1-scale)*x+(w/2-x)*amount).toFixed(2)+'px');
        print.style.setProperty('--j-print-y',((1-scale)*y+(h/2-y)*amount).toFixed(2)+'px');
        print.style.setProperty('--j-map-pan-x',((w/2-x)*amount).toFixed(2)+'px');
        print.style.setProperty('--j-map-pan-y',((h/2-y)*amount).toFixed(2)+'px');
        stage.style.setProperty('--j-fly-pitch',(-.5*amount).toFixed(3)+'deg');
        stage.style.setProperty('--j-fly-yaw',(.6*amount).toFixed(3)+'deg');
        el.style.setProperty('--j-background-blur',(1.5+amount*4).toFixed(3)+'px');
        el.style.setProperty('--j-atmosphere-blur',(24+amount*8).toFixed(3)+'px');
        el.dataset.jFlightX=fx.toFixed(5);el.dataset.jFlightY=fy.toFixed(5);
        renderAtlas(edition,w*scale,h*scale,iw*scale,ih*scale,amount);
        stage.classList.toggle('has-zoom',amount>.002);el.classList.toggle('is-close',amount>.002);el.dataset.jZoom=amount.toFixed(4);syncView();
      }
      function releaseAtlas(){
        if(!atlas)return;atlas.remove();atlas=null;atlasStyle='';atlasNodes=[];el.dataset.jDetailTilesLoaded='0';
      }
      function renderAtlas(edition,w,h,iw,ih,amount){
        if(!amount){if(atlas)atlas.hidden=true;return;}
        if(atlasStyle!==edition.style){
          releaseAtlas();atlas=document.createElement('div');atlas.className='tbj__detail-tiles';atlas.setAttribute('aria-hidden','true');print.appendChild(atlas);atlasStyle=edition.style;
          (edition.detailTiles||[]).forEach(function(tile){
            var node=document.createElement('img');node.alt='';node.width=tile.width;node.height=tile.height;node.decoding='async';node.setAttribute('data-j-detail-tile',tile.role);
            node.style.left=(tile.rect[0]*100)+'%';node.style.top=(tile.rect[1]*100)+'%';node.style.width=(tile.rect[2]*100)+'%';node.style.height=(tile.rect[3]*100)+'%';
            atlas.appendChild(node);atlasNodes.push({node:node,tile:tile});
          });
        }
        atlas.hidden=false;atlas.style.left=((w-iw)/2)+'px';atlas.style.top=((h-ih)/2)+'px';atlas.style.width=iw+'px';atlas.style.height=ih+'px';
        atlas.style.opacity=Math.min(1,amount/.25).toFixed(4);
        var loaded=0;atlasNodes.forEach(function(entry){var decoded=ready(entry.tile.src);entry.node.hidden=!decoded;if(decoded){source(entry.node,entry.tile.src);loaded++;}});
        el.dataset.jDetailTilesLoaded=String(loaded);
      }
      function layer(base,attribute){
        var node=document.createElement('img');node.className=base.className+' tbj__style-layer';node.setAttribute(attribute,'');node.alt='';node.setAttribute('aria-hidden','true');node.width=base.width;node.height=base.height;node.decoding='async';node.hidden=true;base.parentNode.appendChild(node);return node;
      }
      function renderScroll(phase,zoom,flight){
        if(!scrolling)return;lastPhase=phase;if(zoom!==undefined)lastZoom=zoom;if(flight!==undefined)lastFlight=flight;el.dataset.stylePhase=phase.toFixed(4);
        var first=Math.min(order.length-1,Math.floor(phase)),next=Math.min(first+1,order.length-1),part=phase-first;
        var t=Math.max(0,Math.min(1,(part-.15)/.7)),mix=t*t*(3-2*t),detail=el.dataset.view==='detail';
        var from=order[first],to=order[next],fromSrc=detail?from.detail:from.full,toSrc=detail?to.detail:to.full;
        var fromReady=ready(fromSrc),toReady=ready(toSrc);
        /* Keep the last decoded map in view while a fast scroll outruns loading. */
        if(!fromReady){stage.classList.toggle('is-loading',assets.get(fromSrc).state!=='error');return;}
        if(!toReady)mix=0;
        stage.classList.remove('is-loading');stage.classList.toggle('is-detail',detail);
        /* Upgrade the same artwork before moving in; a slow image response never
           interrupts the camera or replaces it with an unrelated crop. */
        if(!detail&&phase>=order.length-1-.4){
          var sharp=from.full.replace(/width=1400/,'width='+from.width);
          if(ready(sharp)&&lastZoom>.001)fromSrc=sharp;
          (order[order.length-1].detailTiles||[]).forEach(function(tile){ready(tile.src);});
        }
        applyZoom(detail?0:lastZoom,from);
        source(img,fromSrc);img.alt=scene.place+' · '+(mix>=.5?to:from).label+' · '+(detail||lastZoom>.3?copy.detail:copy.full);
        source(blendImage,toSrc);blendImage.hidden=first===next||mix===0;blendImage.style.opacity=mix.toFixed(4);
        var fromDetail=from.detail.replace(/width=1400/,'width=900'),toDetail=to.detail.replace(/width=1400/,'width=900');
        var fromOrbit=from.detail.replace(/width=1400/,'width=700'),toOrbit=to.detail.replace(/width=1400/,'width=700');
        if(ready(fromDetail))source(ambient,fromDetail);if(ready(fromOrbit))source(orbit,fromOrbit);
        ambientBlend.hidden=true;orbitBlend.hidden=true;
        if(ready(toDetail)){source(ambientBlend,toDetail);ambientBlend.hidden=first===next||mix===0;ambientBlend.style.opacity=(mix*.1).toFixed(4);}
        if(ready(toOrbit)){source(orbitBlend,toOrbit);orbitBlend.hidden=first===next||mix===0;orbitBlend.style.opacity=mix.toFixed(4);}
        var current=mix>=.5?to:from;if(el.dataset.style!==current.style)syncSelection(current);
        el.dataset.styleBlend=mix.toFixed(4);
        /* Warm only the next edition in this category, not the whole catalogue. */
        if(order[next+1]&&part>.4)ready(detail?order[next+1].detail:order[next+1].full);
      }
      function paint(){
        var edition=selected(scene,el),detail=el.dataset.view==='detail';
        var src=detail?edition.detail:edition.full;
        var id=++requestId;
        stage.classList.add('is-loading');
        var preload=new Image();
        preload.onload=function(){
          if(id!==requestId)return;
          stage.querySelectorAll('.tbj__map-ghost').forEach(function(g){g.remove();});
          var ghost=null;
          if(!reduced&&img.animate&&img.src!==src){ghost=img.cloneNode();ghost.removeAttribute('data-j-image');ghost.alt='';ghost.setAttribute('aria-hidden','true');ghost.classList.add('tbj__map-ghost');stage.appendChild(ghost);}
          img.src=src;img.alt=scene.place+' · '+edition.label+' · '+(detail?copy.detail:copy.full);stage.classList.toggle('is-detail',detail);stage.classList.remove('is-loading');
          el.querySelector('[data-j-ambient]').src=edition.detail.replace(/width=1400/,'width=900');el.querySelector('[data-j-orbit]').src=edition.detail.replace(/width=1400/,'width=700');
          if(ghost){var fade=ghost.animate([{opacity:1},{opacity:0}],{duration:440,easing:'ease-in-out'});fade.onfinish=function(){ghost.remove();};img.animate([{opacity:0},{opacity:1}],{duration:440,easing:'ease-in-out'});}
        };
        preload.onerror=function(){if(id!==requestId)return;stage.classList.remove('is-loading');announce(copy.imageError);};
        preload.src=src;
        syncSelection(edition);
      }
      el.querySelectorAll('[data-j-style]').forEach(function(button){button.addEventListener('click',function(){
        if(saved[scene.id]){saved[scene.id]=button.dataset.style;persist();updateSaved();}
        if(cinema&&cinema.selectStyle(scene.id,button.dataset.style,button))return;
        el.dataset.style=button.dataset.style;paint();announce(scene.place+' · '+selected(scene,el).label);
      });});
      el.querySelectorAll('[data-j-view]').forEach(function(button){button.addEventListener('click',function(){
        el.dataset.view=button.dataset.jView;
        if(scrolling){
          if(button.dataset.jView==='full'&&lastZoom>.002&&cinema.selectStyle(scene.id,el.dataset.style,button))return;
          syncSelection(selected(scene,el));renderScroll(lastPhase);
        }else paint();
      });});
      el.querySelector('[data-j-save]').addEventListener('click',function(){
        if(saved[scene.id]===el.dataset.style)delete saved[scene.id];else saved[scene.id]=el.dataset.style;
        persist();updateSaved();announce(saved[scene.id]?scene.place+' · '+copy.saved:scene.place+' · '+copy.removed);
      });
      controllers.push({editions:order,scroll:renderScroll,release:releaseAtlas,start:function(){
        scrolling=true;requestId++;stage.querySelectorAll('.tbj__map-ghost').forEach(function(g){g.remove();});
        if(img.getAnimations)img.getAnimations().forEach(function(a){a.cancel();});
        if(!blendImage){blendImage=layer(img,'data-j-style-blend');ambientBlend=layer(ambient,'data-j-ambient-blend');orbitBlend=layer(orbit,'data-j-orbit-blend');}
        syncSelection(order[0]);ready(order[0].full);
      },stop:function(){if(!scrolling)return;scrolling=false;lastZoom=0;lastFlight=0;applyZoom(0,selected(scene,el));releaseAtlas();[blendImage,ambientBlend,orbitBlend].forEach(function(node){node.hidden=true;});paint();}});
      if(initial.style!==scene.editions[0].style)paint();
    });
    updateSaved();
    cinema=mountCinema(root,motionQuery,controllers);
    root.querySelectorAll('a[href^="#"]').forEach(function(a){a.addEventListener('click',function(event){
      var href=a.getAttribute('href'),target=root.querySelector(href);if(!target)return;event.preventDefault();if(cinema.navigate(href))return;target.scrollIntoView({behavior:reduced?'auto':'smooth',block:'start'});target.focus({preventScroll:true});
    });});
    if('IntersectionObserver' in window){
      var observer=new IntersectionObserver(function(entries){if(root.dataset.jMotion==='cinematic')return;entries.forEach(function(e){if(!e.isIntersecting)return;root.querySelectorAll('[data-j-stop-link]').forEach(function(a){if(a.dataset.jStopLink===e.target.dataset.stop)a.setAttribute('aria-current','step');else a.removeAttribute('aria-current');});});},{rootMargin:'-25% 0px -45% 0px',threshold:0});
      root.querySelectorAll('[data-stop]').forEach(function(el){observer.observe(el);});
    }
    function dispose(event){if(!event.target.contains(root))return;if(observer)observer.disconnect();if(motionQuery&&motionQuery.removeEventListener)motionQuery.removeEventListener('change',motionChanged);document.removeEventListener('shopify:section:unload',dispose);}
    document.addEventListener('shopify:section:unload',dispose);
    root.querySelectorAll('a[href]').forEach(function(a){if(a.getAttribute('href').charAt(0)!=='#')a.href=localUrl(a.getAttribute('href'));});
    var form=root.querySelector('[data-j-search]'),field=form.querySelector('input[name="q"]'),status=root.querySelector('[data-j-search-status]'),results=root.querySelector('[data-j-results]'),allResults=root.querySelector('[data-j-all-results]');
    var searchRun=0,controller=null;
    function styleKey(text){text=String(text||'').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,'');if(/contrast|azul|taronja|orange/.test(text))return 'contrast';if(/cartograf/.test(text))return 'cartographic';if(/lavanda|lavender|cendra|ceniza/.test(text))return 'lavender';if(/clasic|classic/.test(text))return 'classic';return '';}
    function preferredStyles(){var result=[];scenes.forEach(function(s){if(saved[s.id]&&!result.includes(saved[s.id]))result.push(saved[s.id]);});return result;}
    function searchLink(q){return localUrl('/search?type=product&q='+encodeURIComponent(q));}
    form.addEventListener('submit',async function(event){
      if(!window.fetch)return;
      event.preventDefault();var q=field.value.trim();if(q.length<2){status.textContent=copy.searchShort;field.focus();return;}
      var run=++searchRun;if(controller)controller.abort();controller=new AbortController();
      results.replaceChildren();status.textContent=copy.searching;form.setAttribute('aria-busy','true');allResults.href=searchLink(q);allResults.hidden=false;
      try{
        var endpoint=localUrl('/search/suggest.json?q='+encodeURIComponent(q)+'&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=hide');
        var response=await fetch(endpoint,{signal:controller.signal,headers:{'Accept':'application/json'}});if(!response.ok)throw Error('suggest');
        var data=await response.json();var products=(((data||{}).resources||{}).results||{}).products||[];
        if(run!==searchRun)return;
        if(!products.length){status.textContent=copy.noResults;return;}
        var preferences=preferredStyles();
        var cards=await Promise.all(products.map(async function(p){
          var productUrl=new URL(p.url,location.origin);if(productUrl.origin!==location.origin)return null;
          var handle=productUrl.pathname.split('/products/')[1];if(!handle||handle.includes('/'))return null;
          var matched=null;
          if(preferences.length){
            try{var r=await fetch(localUrl('/products/'+encodeURIComponent(handle)+'.js'),{signal:controller.signal});if(r.ok){var detail=await r.json();for(var i=0;i<preferences.length;i++){matched=(detail.variants||[]).find(function(v){return v.available&&(v.options||[]).some(function(o){return styleKey(o)===preferences[i];});});if(matched)break;}}}catch(error){if(error.name==='AbortError')throw error;}
          }
          var a=document.createElement('a');a.className='tbj__result';if(matched)productUrl.searchParams.set('variant',matched.id);a.href=localUrl(productUrl.pathname+productUrl.search);
          var img=document.createElement('img'),source=matched&&matched.featured_image?matched.featured_image:(p.featured_image||p.image);var src=typeof source==='string'?source:source&&(source.url||source.src);
          if(src){var imageUrl=new URL(src,location.origin);if(imageUrl.protocol==='https:'){imageUrl.searchParams.set('width','420');img.src=imageUrl.href;img.alt=p.title;img.width=210;img.height=145;img.loading='lazy';a.appendChild(img);}}
          var title=document.createElement('strong');title.textContent=p.title;a.appendChild(title);
          if(matched){var label=document.createElement('small');label.textContent=copy.match+' · '+matched.options.filter(function(o){return styleKey(o);}).join(' ');a.appendChild(label);}
          return a;
        }));
        if(run!==searchRun)return;cards.filter(Boolean).forEach(function(a){results.appendChild(a);});status.textContent=copy.results;
      }catch(error){if(run===searchRun&&error.name!=='AbortError')status.textContent=copy.searchError;}
      finally{if(run===searchRun)form.removeAttribute('aria-busy');}
    });
  }
  function init(){document.querySelectorAll('[data-trobart-journey]').forEach(mount);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',init);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trobart-maps-hero"] && !Shopify.designMode) return;
  try {
    
/* A presentation count-up to the verified total; no weekly sales data is exposed. */
(function(){
  function mount(root){
    if(root.dataset.salesMounted)return;root.dataset.salesMounted='1';
    var node=root.querySelector('[data-sales-number]'),total=Number(root.dataset.total);
    if(!node||!Number.isSafeInteger(total)||total<0)return;
    var media=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)');
    var current=total,timer=0,observer=null,visible=!('IntersectionObserver' in window),done=false,disposed=false;
    function paint(n){node.textContent=String(n).replace(/\B(?=(\d{3})+(?!\d))/g,'.');}
    function cancel(){if(timer)clearTimeout(timer);timer=0;}
    function finish(){cancel();done=true;current=total;paint(total);if(observer)observer.disconnect();}
    function schedule(){
      if(done||disposed||timer||!visible||document.hidden)return;
      timer=setTimeout(function(){
        timer=0;if(disposed||!visible||document.hidden)return;
        if(media&&media.matches){finish();return;}
        current=Math.min(total,current+1);paint(current);
        if(current===total)finish();else schedule();
      },500);
    }
    function motion(){if(media&&media.matches)finish();}
    function visibility(){if(document.hidden)cancel();else schedule();}
    function unload(event){
      if(!event.target.contains(root))return;
      disposed=true;cancel();if(observer)observer.disconnect();
      if(media&&media.removeEventListener)media.removeEventListener('change',motion);
      document.removeEventListener('visibilitychange',visibility);
      document.removeEventListener('shopify:section:unload',unload);
    }
    paint(total);
    if(total===0||media&&media.matches)return;
    current=Math.max(0,total-(20+Math.floor(Math.random()*31)));paint(current);
    document.addEventListener('visibilitychange',visibility);
    document.addEventListener('shopify:section:unload',unload);
    if(media&&media.addEventListener)media.addEventListener('change',motion);
    if('IntersectionObserver' in window){
      observer=new IntersectionObserver(function(entries){
        visible=entries.some(function(e){return e.isIntersecting&&e.intersectionRatio>=.5;});
        if(visible)schedule();else cancel();
      },{threshold:.5});observer.observe(root);
    }else schedule();
  }
  function init(){document.querySelectorAll('[data-sales-proof]').forEach(mount);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',init);
})();

/* Equal collection chance, then a uniformly sampled product within that collection. */
(function(){
  function mount(root){
    if(root.dataset.catalogueMounted||!root.tbHero||!root.tbHero.setMapPicker)return;
    var groups;
    try{groups=JSON.parse(root.querySelector('.tb-collections').textContent);}catch(_){return;}
    groups=groups.filter(function(g){return g&&g.count>0&&g.url&&new URL(g.url,location.origin).origin===location.origin;});
    if(!groups.length)return;
    root.dataset.catalogueMounted='collections';
    root.dataset.catalogueCollectionCount=String(groups.length);
    var api=root.tbHero,cache=new Map(),controllers=new Set(),loaded=new Set(),queued=null;
    var disposed=false,interacted=false,initial=true,current='';
    function key(m){return String(m.id)+':'+(m.vid||'');}
    function valid(m){return m&&m.id&&m.t&&m.u&&m.img&&m.w>=900&&m.h>0&&m.a>0;}
    async function page(group,n){
      var id=group.handle+':'+n,cached=cache.get(id);
      if(cached&&Date.now()-cached.time<60000)return cached.data;
      var url=new URL(group.url,location.origin),controller=new AbortController();
      url.searchParams.set('view','trobart-hero-feed');url.searchParams.set('sort_by','created-descending');url.searchParams.set('page',n);
      controllers.add(controller);
      var timeout=setTimeout(function(){controller.abort();},12000);
      try{
        var response=await fetch(url.href,{credentials:'same-origin',signal:controller.signal});
        if(!response.ok)throw new Error('Catalogue unavailable');
        var data=await response.json();
        if(disposed)return null;
        if(!data||!Array.isArray(data.maps)||!Number.isInteger(data.total)||data.total<0||!Number.isInteger(data.pages)||data.pages<1)throw new Error('Invalid catalogue');
        group.count=data.total;
        cache.delete(id);cache.set(id,{time:Date.now(),data:data});
        if(cache.size>16)cache.delete(cache.keys().next().value);
        loaded.add(id);root.dataset.cataloguePagesLoaded=String(loaded.size);
        return data;
      }finally{clearTimeout(timeout);controllers.delete(controller);}
    }
    async function draw(){
      // Product counts never enter this first draw. A 947-map collection has one share.
      var group=groups[Math.floor(Math.random()*groups.length)];
      for(var attempt=0;attempt<3&&!disposed;attempt++){
        if(!group.count)return null;
        var index=Math.floor(Math.random()*group.count),data=await page(group,Math.floor(index/24)+1);
        if(!data)return null;
        var item=data.maps.find(function(m){return m.slot===index%24&&valid(m);});
        if(item&&(key(item)!==current||group.count===1||attempt===2))return Object.assign({},item,{collection:group.handle});
      }
      // Keep the visible map on a failed/empty draw; never fall back to a size-weighted pool.
      return null;
    }
    function warm(){
      if(!queued&&!disposed&&!document.hidden)queued=draw().catch(function(){return null;});
      return queued;
    }
    async function pick(){
      if(disposed||document.hidden)return null;
      var ready=warm();queued=null;
      var item=await ready;
      if(disposed||document.hidden)return null;
      if(item)current=key(item);
      warm();
      return item;
    }
    function start(){
      var ready=warm();
      if(ready&&initial)ready.then(function(){
        if(!disposed&&!document.hidden&&!interacted&&initial){initial=false;api.random();}
      });
    }
    function change(event){current=String(event.detail.id)+':'+(event.detail.variant||'');}
    function interaction(){interacted=true;initial=false;}
    function visibility(){if(!document.hidden)start();}
    function unload(event){
      if(!event.target.contains(root))return;
      disposed=true;controllers.forEach(function(c){c.abort();});cache.clear();api.setMapPicker(null);
      root.removeEventListener('trobart:map-change',change);root.removeEventListener('pointerdown',interaction);root.removeEventListener('keydown',interaction);
      document.removeEventListener('visibilitychange',visibility);document.removeEventListener('shopify:section:unload',unload);
    }
    api.setMapPicker(pick);
    root.addEventListener('trobart:map-change',change);
    root.addEventListener('pointerdown',interaction,{passive:true});root.addEventListener('keydown',interaction);
    document.addEventListener('visibilitychange',visibility);document.addEventListener('shopify:section:unload',unload);
    start();
  }
  function boot(){document.querySelectorAll('.tb-hero--trobart[data-catalogue]').forEach(mount);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
  document.addEventListener('shopify:section:load',boot);
  window.addEventListener('trobart:hero-ready',boot);
})();


  } catch(e) { console.error(e); }
})();
})();
